<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/css/public.css';

#app {
  font-family: Helvetica Neue,Segoe UI,Hiragino Sans GB,Microsoft YaHei,Verdana,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue